<template>
    <div class="subtasks">
        <div
            :class="{'stream-name': true, 'stream-name_active': selectedStream.id === taskStream.id}"
            v-for="taskStream in taskStreamList" :key="taskStream.id"
            @click="selectStream(taskStream.id)"
        >
            <span>{{ taskStream.name }}</span>
            <Icon
                v-if="taskStreamList.length > 1 && isAccessAllow"
                id="delete"
                @click.stop="deleteConfirm = taskStream"
            />
        </div>

        <SubtasksNew
            v-if="isAccessAllow"
            :urlTaskId="urlTaskId"
        />

        <ReactiveConfirm
            v-if="deleteConfirm"
            @close="deleteConfirm = null"
            @confirm="deleteStream"
            confirmText="Удалить"
            :title='`Удалить подзадачу <br>"${deleteConfirm.name}?"`'>
        </ReactiveConfirm>
    </div>
</template>

<script>
import {mapState} from "vuex";
import SubtasksNew from "@/vue/plan/url/Task/SubtasksNew";

export default {
    name: "Subtasks",
    components: {SubtasksNew},
    props: ['isAccessAllow', 'urlTaskId', 'service', 'runId', 'urlId'],
    data() {
        return {
            deleteConfirm: null,
        }
    },
    computed: mapState({
        // Fetched by `fetchPlanUrlTaskStreamList`
        taskStreamList: state => state.planUrl.taskStreamList,
        selectedStream: state => state.planUrl.selectedStream,
    }),
    mounted() {
        this.$store.dispatch('fetchPlanUrlTaskStreamList', {taskId: this.urlTaskId});
    },
    methods: {
        selectStream(streamId) {
            this.$store.dispatch('selectStream', {
              streamId,
              service: this.service,
              runId: this.runId,
              urlId: this.urlId,
            });
        },
        deleteStream() {
            if (this.deleteConfirm?.id) {
                this.$store.dispatch('deletePlanUrlStage', {streamId: this.deleteConfirm.id});
                this.deleteConfirm = null;
            }
        }
    }
}
</script>

<style lang="scss">
.subtasks {
    .stream-name {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        padding: 10px 8px;
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #000000;
        cursor: pointer;

        .icon {
            color: #421D57;
        }

        &_active, &:hover {
            background: #30B68F;
            color: #fff;

            .icon {
                color: #FFF;
            }
        }

        &:hover:not(.stream-name_active) {
            background: rgba(48, 182, 143, 0.6);
        }
    }
}
</style>
